// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__qokOH","requiredAsterisk":"Info_requiredAsterisk__234Cl"};